export default __webpack_public_path__ + "static/media/gallery02.27663bd9.png";